import Vue from 'vue'
import Vuex from 'vuex'
import Task from './module/Task'


Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    Task
  }
});


export default store

